import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { ADMIN_GENERAL_SETTINGS_ROUTE_NAME } from '@modules/general-settings/constants';
import {
  ADMIN_GENERAL_SETTINGS_FULL_STATS_ACCESS_PERMISSIONS,
  ADMIN_GENERAL_SETTINGS_FULL_STATS_ACCESS_ROUTE_NAME,
  TRANSLATION_GROUP_GENERAL_SETTINGS_FULL_STATS_ACCESS,
} from '@modules/general-settings/submodules/full-stats-access/constants';
import { useI18n } from '@modules/i18n/composables';

import { getTranslationKeys } from './translations';

export class AdminGeneralSettingsFullStatsAccessModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_GENERAL_SETTINGS_ROUTE_NAME, {
      name: ADMIN_GENERAL_SETTINGS_FULL_STATS_ACCESS_ROUTE_NAME,
      path: 'view_all_statistics',

      component: () => import('@modules/general-settings/submodules/full-stats-access/pages/AdminGeneralSettingsFullStatsAccessPage/AdminGeneralSettingsFullStatsAccessPage.vue'),
      permission: ADMIN_GENERAL_SETTINGS_FULL_STATS_ACCESS_PERMISSIONS.PROJECTSETTINGS_ADMINS_WITH_FULL_STATS_ACCESS,
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_GENERAL_SETTINGS_ROUTE_NAME, {
      caption: getTPath(TRANSLATION_GROUP_GENERAL_SETTINGS_FULL_STATS_ACCESS, 'TAB_NAME'),
      to: {
        name: ADMIN_GENERAL_SETTINGS_FULL_STATS_ACCESS_ROUTE_NAME,
      },
      permission: ADMIN_GENERAL_SETTINGS_FULL_STATS_ACCESS_PERMISSIONS.PROJECTSETTINGS_ADMINS_WITH_FULL_STATS_ACCESS,
      id: ADMIN_GENERAL_SETTINGS_FULL_STATS_ACCESS_ROUTE_NAME,
      order: 80,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_GENERAL_SETTINGS_FULL_STATS_ACCESS, getTranslationKeys);
  }
}
